import { render } from "./AddExerciseSheetQuestionType.vue?vue&type=template&id=582b0b33"
import script from "./AddExerciseSheetQuestionType.vue?vue&type=script&lang=js"
export * from "./AddExerciseSheetQuestionType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__